// The app's language, translations and number/date formats.
import { STRINGS, compassIndex, isLang, translator, type LangCode } from "../shared/strings.ts";
import { lsGet, lsSet } from "./util.ts";

function browserLang(): LangCode {
  for (const l of navigator.languages ?? [navigator.language ?? ""]) {
    const code = String(l).slice(0, 2).toLowerCase();
    if (isLang(code)) return code;
  }
  return "en";
}
const saved = lsGet("lang", "");
export let LANG: LangCode = isLang(saved) ? saved : browserLang();
export let LOCALE = "en-GB";

/** t("key", ...values): the text in the current language. list(): direction and moon lists. nameOf(): species etc. */
export const { t, list, nameOf } = translator(() => LANG);

export let dFmt: Intl.DateTimeFormat, dFmtY: Intl.DateTimeFormat, tFmt: Intl.DateTimeFormat, mFmt: Intl.DateTimeFormat;
export function setFormats(): void {
  LOCALE = t("_locale");
  dFmt = new Intl.DateTimeFormat(LOCALE, { weekday: "short", day: "numeric", month: "short" });
  dFmtY = new Intl.DateTimeFormat(LOCALE, { day: "numeric", month: "short", year: "numeric" });
  tFmt = new Intl.DateTimeFormat(LOCALE, { hour: "2-digit", minute: "2-digit" });
  mFmt = new Intl.DateTimeFormat(LOCALE, { month: "long", year: "numeric" });
}
setFormats();

/** Switches the language (the caller redraws the screen). */
export function setLangCode(code: LangCode): void {
  LANG = code;
  lsSet("lang", code);
  setFormats();
}
export const languages = (): [LangCode, string][] => Object.entries(STRINGS).map(([code, L]) => [code as LangCode, L._name]);

export const fmtNum = (n: number | null | undefined, digits = 1): string => n == null ? "" : n.toLocaleString(LOCALE, { maximumFractionDigits: digits });
/** "Mon 19 Oct · 18:30" (with the year when it isn't this year). */
export const fmtWhen = (ts: number): string => (new Date(ts).getFullYear() === new Date().getFullYear() ? dFmt : dFmtY).format(ts) + " · " + tFmt.format(ts);
export const fmtMonth = (ts: number): string => { const s = mFmt.format(ts); return s.charAt(0).toUpperCase() + s.slice(1); };
/** Short direction ("SE") for tight spots like the catch list. */
export const compass = (deg: number): string => list("compass")[compassIndex(deg)];
/** "from the east" / "idästä". */
export const windFrom = (deg: number): string => list("dirFrom")[compassIndex(deg)];

export const speciesLabel = (id: string): string => nameOf("species", id) ?? id;
export const methodLabel = (id: string): string => nameOf("methods", id) ?? id;
export const pinTypeLabel = (type: string): string => nameOf("pinTypes", type) ?? type;
export const huntStyleLabel = (id: string): string => nameOf("huntStyles", id) ?? id;
